module.exports = __webpack_public_path__ + "static/media/ce.9bcdc1bd.png";